import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "search-products-form"
};
const _hoisted_2 = {
  key: 0,
  class: "item-selection"
};
const _hoisted_3 = {
  class: "img"
};
const _hoisted_4 = {
  class: "desc"
};
const _hoisted_5 = {
  key: 1,
  class: "search-input-wrap"
};
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = {
  class: "img"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "desc"
};
import { ref, onBeforeMount, computed } from "vue";
import { useOverlayStore } from "@/stores";
import { useConfiguratorStore } from "@/stores/configuratorData";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import { ElButton } from "element-plus";
import { ElAutocomplete } from "element-plus";
export default /*@__PURE__*/_defineComponent({
  __name: 'searchProducts',
  emits: ["switchMainProduct"],
  setup(__props, {
    emit: __emit
  }) {
    const store = useConfiguratorStore();
    const loading = ref(true);
    const state = ref("");
    const autocompleteRef = ref(null);
    const handleAutoIcon = () => {
      const autocomplete = autocompleteRef.value;
      if (autocomplete) {
        autocomplete.inputRef.input.parentElement.parentElement.parentElement.classList.add("el-autocomplete-focus");
      }
    };
    const toggleDropdown = event => {
      event.preventDefault();
      event.stopPropagation();
      const autocomplete = autocompleteRef.value;
      if (autocomplete) {
        autocomplete.inputRef.input.parentElement.parentElement.parentElement.classList.remove("el-autocomplete-focus");
      }
    };
    const placeholderImage = ref("");
    placeholderImage.value = require(process.env.VUE_APP_PLACEHOLDER_IMAGE);
    const querySearch = (queryString, cb) => {
      const FilteredData = [];
      store.thumbnails?.products.map(item => {
        item.productDisplayCode.forEach(code => {
          if (code.toLowerCase().replace(/[^a-zA-Z0-9]|x/g, "").includes(queryString.toLowerCase().replace(/[^a-zA-Z0-9]|x/g, ""))) {
            if (typeof item.productModelCode != "string") {
              item.productModelCode.map(element => {
                FilteredData.push(element);
              });
            }
          }
        });
        if (item.productMainCode) {
          item.productMainCode.forEach(code => {
            if (code.toLowerCase().replace(/[^a-zA-Z0-9]|x/g, "").includes(queryString.toLowerCase().replace(/[^a-zA-Z0-9]|x/g, ""))) {
              if (typeof item.productModelCode != "string") {
                item.productModelCode.map(element => {
                  FilteredData.push(element);
                });
              }
            }
          });
        }
      });
      const results = queryString ? store.getConfigureDataTypes.filter(createFilter(queryString, FilteredData)) : store.getConfigureDataTypes;
      cb(results);
    };
    function getImageUrl(codeTypeId) {
      if (additionalAttrStore.dataConfig.shellModels?.map(data => data.toUpperCase())?.includes(codeTypeId.toUpperCase())) {
        return additionalAttrStore.getDataConfig.thumbnailsPlaceholderUrl;
      }
      return store.getImageByCodeTypeId(codeTypeId)?.rs_w90_h90_image ?? additionalAttrStore.getDataConfig.thumbnailsPlaceholderUrl;
    }
    const selectionItems = computed(() => {
      const result = [];
      for (const codeTypeId of additionalAttrStore.getIds) {
        const initData = store.getConfigureDataTypes.find(item => item.Id === codeTypeId);
        const imageUrl = getImageUrl(codeTypeId);
        result.push({
          ...initData,
          imageUrl
        });
      }
      return result;
    });
    const createFilter = (queryString, FilteredData) => {
      return restaurant => {
        return FilteredData.includes(restaurant.Id) || restaurant.Text.toLowerCase().includes(queryString.toLowerCase()) || restaurant.Description.toLowerCase().includes(queryString.toLowerCase()) || restaurant.Id.toLowerCase().replace(/[^a-zA-Z0-9]|x/g, "").includes(queryString.toLowerCase().replace(/[^a-zA-Z0-9]|x/g, ""));
      };
    };
    const emit = __emit;
    const additionalAttrStore = useAdditionalAttrStore();
    const handleSelect = item => {
      additionalAttrStore.setConfigByItem(item);
      emit("switchMainProduct");
    };
    const overlayStore = useOverlayStore();
    onBeforeMount(async () => {
      if (overlayStore.showProductDetailpage === false) {
        await store.initilizeConfigurator();
        loading.value = false;
      }
      loading.value = overlayStore.showLoading;
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
      const _component_el_skeleton = _resolveComponent("el-skeleton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("search.welcome")), 1), selectionItems.value.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectionItems.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.Id
        }, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_image, {
          style: {
            "width": "64px",
            "height": "64px"
          },
          src: item.imageUrl,
          fit: "contain"
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("h3", null, _toDisplayString(item.Text), 1), _createElementVNode("p", null, _toDisplayString(item.Description), 1)]), _createVNode(_unref(ElButton), {
          class: "primary-button",
          type: "primary",
          onClick: $event => handleSelect(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.selectProduct")), 1)]),
          _: 1
        }, 8, ["onClick"])]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_skeleton, {
        loading: loading.value,
        animated: ""
      }, {
        template: _withCtx(() => [_createVNode(_component_el_skeleton_item, {
          variant: "rect",
          style: {
            "width": "100%",
            "height": "60px"
          }
        })]),
        default: _withCtx(() => [_createVNode(_unref(ElAutocomplete), {
          modelValue: state.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.value = $event),
          "fetch-suggestions": querySearch,
          "popper-class": "configurator-products-autocomplete",
          placeholder: _ctx.$t('search.placeholder'),
          onSelect: handleSelect,
          ref_key: "autocompleteRef",
          ref: autocompleteRef
        }, {
          prefix: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("i", {
            class: "iconfont icon-search"
          }, null, -1)]))]),
          suffix: _withCtx(() => [_createElementVNode("div", {
            class: "as-dropdown",
            onClick: handleAutoIcon
          }, [...(_cache[3] || (_cache[3] = [_createElementVNode("i", {
            class: "iconfont icon-menu"
          }, null, -1), _createElementVNode("i", {
            class: "iconfont icon-arrow-down"
          }, null, -1)]))])]),
          default: _withCtx(({
            item
          }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_image, {
            style: {
              "width": "64px",
              "height": "64px"
            },
            src: getImageUrl(item.Id),
            fit: "contain"
          }, {
            error: _withCtx(() => [_createElementVNode("img", {
              width: "64px",
              height: "64px",
              style: {
                "opacity": "0.5"
              },
              src: placeholderImage.value,
              alt: "Placeholder"
            }, null, 8, _hoisted_8)]),
            _: 1
          }, 8, ["src"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("h3", null, _toDisplayString(item.Text), 1), _createElementVNode("p", null, _toDisplayString(item.Description), 1)])])]),
          _: 1
        }, 8, ["modelValue", "placeholder"]), _createElementVNode("div", {
          class: "hide-icon",
          onClick: _cache[1] || (_cache[1] = $event => toggleDropdown($event))
        })]),
        _: 1
      }, 8, ["loading"])]))]);
    };
  }
});